import React from 'react';
import { connect } from 'react-redux';
import HeaderMultiPaymentEvenSplit from
  '../../../components/purchase-dashboard/autopilot/header.multi-payment.even-split';
import HeaderMultiPaymentSPP from
  '../../../components/purchase-dashboard/autopilot/header.multi-payment.spp';
import HeaderSinglePaymentEvenSplit from
  '../../../components/purchase-dashboard/autopilot/header.single-payment.even-split';
import HeaderSinglePaymentSPP from
  '../../../components/purchase-dashboard/autopilot/header.single-payment.spp';
import Purchase from '../../../lib/purchase';

const HeaderContainer = ({ costType, payments, splitType }) => {
  if (Purchase.isSinglePayment(payments)) {
    if (Purchase.isSpecifiedPerPerson(splitType)) return <HeaderSinglePaymentSPP />;
    return <HeaderSinglePaymentEvenSplit />;
  }

  if (Purchase.isEvenSplit(splitType) || Purchase.isPerSlot(costType)) {
    return <HeaderMultiPaymentEvenSplit />;
  }

  return <HeaderMultiPaymentSPP />;
};

const mapStateToProps = ({ purchases }) => {
  const purchase = purchases.byId[purchases.current];
  return {
    payments: purchase.payments,
    splitType: purchase.group.splitType,
    costType: purchase.product.costType,
  };
};

export default connect(mapStateToProps)(HeaderContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/autopilot/header.container.js